/* ============================================================
   NUMBZ SHOPIFY THEME — theme.js
   Handles: age gate, mobile menu, FAQ accordion, cart, product variants
   ============================================================ */

(function () {
  'use strict';

  var FLAVOR_COLORS = {
   
  };

  function getFlavorFromVariantTitle(title) {
    if (!title) return '';
    var parts = title.split(' / ');
    return parts.length > 1 ? parts[parts.length - 1].trim() : title.trim();
  }

  function getFlavorColor(flavor) {
    return FLAVOR_COLORS[flavor] || '#E91E8C';
  }

  function normalizeColor(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      if (value.value) return value.value;
      if (typeof value.red === 'number') {
        return '#' + [value.red, value.green, value.blue].map(function (channel) {
          var hex = Math.round(channel).toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        }).join('');
      }
    }
    return '';
  }

  function parseJsonAttribute(el, attr) {
    if (!el) return null;
    var raw = el.getAttribute(attr);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = raw;
      try {
        return JSON.parse(textarea.value);
      } catch (e2) {
        return null;
      }
    }
  }

  function parseMoneyToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return value;
    var match = String(value).replace(/[^\d.,]/g, '').match(/[\d,]+\.?\d*|\.\d+/);
    if (!match) return 0;
    return Math.round(parseFloat(match[0].replace(/,/g, '')) * 100);
  }

  function findVariantById(variants, id, buttons) {
    var i;
    for (i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    if (!buttons || !buttons.length) return null;
    for (i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (String(btn.getAttribute('data-variant-id')) !== String(id)) continue;
      return {
        id: id,
        title: btn.getAttribute('data-flavor-option') || btn.textContent.trim(),
        price: parseMoneyToCents(btn.getAttribute('data-price')),
        available: btn.getAttribute('data-available') !== 'false'
      };
    }
    return null;
  }

  function needsDarkText(hex) {
    if (!hex || hex.charAt(0) !== '#' || hex.length < 7) return false;
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 160;
  }

  /* ── Age Gate ── */
  function initAgeGate() {
    var overlay = document.getElementById('age-gate');
    if (!overlay) return;
    var verified = localStorage.getItem('numbz_age_verified');
    if (verified === 'true') {
      overlay.classList.add('hidden');
      return;
    }
    overlay.classList.remove('hidden');

    var yesBtn = document.getElementById('age-gate-yes');
    var noBtn  = document.getElementById('age-gate-no');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        localStorage.setItem('numbz_age_verified', 'true');
        overlay.classList.add('hidden');
      });
    }
    if (noBtn) {
      noBtn.addEventListener('click', function () {
        window.location.href = 'https://www.google.com';
      });
    }
  }

  /* ── Mobile Menu ── */
  function initMobileMenu() {
    var btn  = document.getElementById('burger-btn');
    var menu = document.getElementById('mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      // Swap icon
      var iconOpen  = btn.querySelector('.icon-menu');
      var iconClose = btn.querySelector('.icon-close');
      if (iconOpen)  iconOpen.style.display  = isOpen ? 'none'  : 'block';
      if (iconClose) iconClose.style.display = isOpen ? 'block' : 'none';
    });

    // Close on link click
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        var iconOpen  = btn.querySelector('.icon-menu');
        var iconClose = btn.querySelector('.icon-close');
        if (iconOpen)  iconOpen.style.display  = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }

  /* ── FAQ Accordion ── */
function initFaqAccordion() {
  var items = document.querySelectorAll('.faq-item');

  items.forEach(function (item) {
    var btn = item.querySelector('.faq-question');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');

      // Close all
      items.forEach(function (i) {
        i.classList.remove('open');
      });

      // Open clicked item
      if (!isOpen) {
        item.classList.add('open');
      }

      // Update every chevron
      items.forEach(function (i) {
        var chevron = i.querySelector('.faq-chevron');
        if (!chevron) return;
       

       var color = (item.dataset.color || "#E91E8C").replace(/"/g, "");
        

        chevron.style.background = i.classList.contains('open')
          ? color
          : 'rgba(0,0,0,0.06)';
          chevron.style.color = i.classList.contains("open")
  ? "#fff"
  : "#000";
      });
    });
  });
}

  function getProductVariants(page) {
    var scriptEl = page.querySelector('[data-product-variants]');
    if (scriptEl && scriptEl.textContent) {
      try {
        var parsed = JSON.parse(scriptEl.textContent.trim());
        if (Array.isArray(parsed)) return parsed;
      } catch (e) {}
    }
    var fromAttr = parseJsonAttribute(page, 'data-variants');
    return Array.isArray(fromAttr) ? fromAttr : [];
  }

  function getVariantMetafields(page) {
    var metafieldsEl = page.querySelector('[data-variant-metafields]') ||
      document.getElementById('variant-metafields');
    if (!metafieldsEl || !metafieldsEl.textContent) return {};
    try {
      return JSON.parse(metafieldsEl.textContent);
    } catch (e) {
      return {};
    }
  }

  function getProductPageContext(page) {
    var form = page.querySelector('#product-form') || page.querySelector('form[action*="/cart/add"]');
    var productImage = page.querySelector('[data-product-image]') || document.getElementById('product-main-image');
    if (!page.getAttribute('data-default-image') && productImage && productImage.getAttribute('src')) {
      page.setAttribute('data-default-image', productImage.getAttribute('src'));
    }
    return {
      form: form,
      variantInput: form ? form.querySelector('[name="id"]') : null,
      qtyInput: form ? form.querySelector('[data-quantity-input]') : null,
      qtyDisplay: form ? form.querySelector('[data-quantity-display]') : null,
      qtyMinus: form ? form.querySelector('[data-quantity-minus]') : null,
      variantButtons: page.querySelectorAll('[data-variant-id]'),
      flavorEl: page.querySelector('[data-active-flavor]'),
      priceEl: page.querySelector('[data-product-price]'),
      submitBtn: form ? form.querySelector('.add-to-cart-btn') : null,
      productImage: productImage,
      defaultImageUrl: page.getAttribute('data-default-image') || '',
      variants: getProductVariants(page),
      variantMetafields: getVariantMetafields(page)
    };
  }

  function formatProductMoney(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '$' + amount;
  }

  function getActiveVariantButton(buttons, variantId) {
    var i;
    for (i = 0; i < buttons.length; i++) {
      if (String(buttons[i].getAttribute('data-variant-id')) === String(variantId)) {
        return buttons[i];
      }
    }
    return null;
  }

  function getProductQuantity(ctx) {
    return Math.max(1, parseInt(ctx.qtyInput ? ctx.qtyInput.value : 1, 10) || 1);
  }

  function getSelectedProductVariant(ctx) {
    var id = ctx.variantInput ? ctx.variantInput.value : '';
    if (!id) return null;
    return findVariantById(ctx.variants, id, ctx.variantButtons);
  }

  function getVariantPriceCents(variant, activeBtn) {
    if (variant && variant.price != null && variant.price !== '') {
      return Number(variant.price);
    }
    if (activeBtn) return parseMoneyToCents(activeBtn.getAttribute('data-price'));
    return 0;
  }

  function getVariantImageUrl(variant, activeBtn, defaultImageUrl) {
    if (activeBtn) {
      var btnImage = activeBtn.getAttribute('data-image');
      if (btnImage) return btnImage;
    }
    if (!variant) return defaultImageUrl || '';
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_image && typeof variant.featured_image === 'string') return variant.featured_image;
    return defaultImageUrl || '';
  }

  function setProductImage(ctx, imageUrl) {
    if (!ctx.productImage) return;
    var nextUrl = imageUrl || ctx.defaultImageUrl;
    if (!nextUrl) return;
    ctx.productImage.src = nextUrl;
    if (ctx.productImage.hasAttribute('srcset')) ctx.productImage.removeAttribute('srcset');
  }

  function updateProductPageUI(page) {
    var ctx = getProductPageContext(page);
    var variant = getSelectedProductVariant(ctx);
    if (!variant) return;

    var activeBtn = getActiveVariantButton(ctx.variantButtons, variant.id);
    var flavor = (activeBtn && activeBtn.getAttribute('data-flavor-option')) ||
      getFlavorFromVariantTitle(variant.title);
    var metafields = ctx.variantMetafields[String(variant.id)] || {};
    var metafieldColor = normalizeColor(metafields.variant_color_pdp);
    var color = metafieldColor || getFlavorColor(flavor);

  
    var darkText = needsDarkText(color);
    var quantity = getProductQuantity(ctx);
    var priceCents = getVariantPriceCents(variant, activeBtn);
    var isAvailable = variant.available !== false;

    if (ctx.flavorEl) ctx.flavorEl.textContent = flavor;
    if (ctx.priceEl) {
      ctx.priceEl.textContent = activeBtn && activeBtn.getAttribute('data-price') && priceCents === 0
        ? activeBtn.getAttribute('data-price')
        : formatProductMoney(priceCents);
    }

    ctx.variantButtons.forEach(function (btn) {
      var selected = String(btn.getAttribute('data-variant-id')) === String(variant.id);
      btn.classList.toggle('active', selected);
      
     
       
       const brdrcolor = `rgba(${parseInt(color.slice(1,3),16)}, ${parseInt(color.slice(3,5),16)}, ${parseInt(color.slice(5,7),16)}, 0.3)`;
       const backgcolor = `rgba(${parseInt(color.slice(1,3),16)}, ${parseInt(color.slice(3,5),16)}, ${parseInt(color.slice(5,7),16)}, 0.064)`;
       const pagebg=`rgba(${parseInt(color.slice(1,3),16)}, ${parseInt(color.slice(3,5),16)}, ${parseInt(color.slice(5,7),16)}, 0.1)`;
       const iconsbg=`rgba(${parseInt(color.slice(1,3),16)}, ${parseInt(color.slice(3,5),16)}, ${parseInt(color.slice(5,7),16)}, 0.082)`;
       const iconsin=`rgba(${parseInt(color.slice(1,3),16)}, ${parseInt(color.slice(3,5),16)}, ${parseInt(color.slice(5,7),16)}, 0.145)`;

      const btnVariantId = btn.getAttribute('data-variant-id');
      const btnMetafields = ctx.variantMetafields[String(btnVariantId)] || {};
      const btnColor = normalizeColor(btnMetafields.variant_color_pdp);

       const info = btnMetafields.variant_info;

      if (selected && info) {
        //  console.log(info.flavor_profile);     
        //  console.log(info.attributes_0_10);     


          const attributes = document.querySelectorAll('.details_con .attribute');
          const values = info.attributes_0_10;

          attributes.forEach((attribute, index) => {
              const value = values[index] ?? 0;

             
              const percent = (value / 10) * 100;

              const fill = attribute.querySelector('.attribute-fill');
              const dot = attribute.querySelector('.attribute-dot');

              fill.style.width = percent + '%';
              dot.style.left = percent + '%';
          });


           document.querySelector(".product-dt-sum").innerHTML = info.flavor_profile;

           document.querySelectorAll(".attribute-dot.absolute").forEach(el => {
              el.style.background = btnColor;
          });

          document.querySelectorAll(".attribute-fill.absolute").forEach(el => {
              el.style.background = brdrcolor;
          });


        }

        if(selected && color){

           

           document.querySelectorAll(".product-details-panel__heading-bar").forEach(el => {
              el.style.background = color;
     
            });

           document.querySelector(".education-label").style.color = color ;  




            document.querySelectorAll(".cer_svg").forEach(el => {
              el.style.color = color;
              el.style.background=iconsbg;
            });
            
                

                document.querySelectorAll(".why-tab.active").forEach(el => {
             
              el.style.background=color;
            });
              document.querySelectorAll(".why-format-panel>h3").forEach(el => {
             
              el.style.color=color;
            });







            document.querySelectorAll(".why-check").forEach(el => {
             
              el.style.background=color;
            });

              document.querySelectorAll(".why-tab").forEach(tab => {
              tab.addEventListener("click", function () {
                document.querySelectorAll(".why-tab").forEach(el => {
                  el.classList.remove("active");
                  el.style.background = "";
                });

                this.classList.add("active");
                this.style.background = color;

                document.querySelectorAll(".why-format-panel > h3").forEach(h3 => {
                  h3.style.color = color;
                });

                document.querySelectorAll(".why-check").forEach(check => {
                  check.style.background = color;
                });
              });
            });


            document.querySelectorAll(".education-tab").forEach(tab => {
              tab.addEventListener("click", function () {
                document.querySelectorAll(".education-tab").forEach(el => {
                  el.classList.remove("active");
                  el.style.background = "";
                });

                this.classList.add("active");
                this.style.background = color;

                document.querySelectorAll(".education-kicker>span").forEach(span => {
                  span.style.color = color;
                });
                document.querySelectorAll(".education-kicker>i").forEach(lne => {
                  lne.style.background = color;
                });

              ;
              });
            });


               document.querySelectorAll(".education-stats strong").forEach(el => {
             
              el.style.color=color;
            });

                document.querySelector(".education-kicker>span").style.color=color;
                 document.querySelector(".education-kicker>i").style.background=color;     


               
                  
            document.querySelector(".product-details-panel__accent").style.background=color;


               document.querySelector(".education-tab.active").style.background=color;


            

            document.querySelectorAll(".science-stat").forEach(el => {
             
              el.style.background=iconsbg;
            });
             document.querySelectorAll(".science-stat__number").forEach(el => {
              el.style.color = color;
             
            });

             document.querySelectorAll(".process-flow__circle").forEach(el => {
              el.style.background = color;
             
            });

            document.querySelectorAll(".science-card__check").forEach(el => {
              el.style.background = color;
             
            });
            document.querySelector(".science-section").style.background=backgcolor;
          
              document.querySelector(".process-flow__line").style.borderColor=color;
          

      }


      const btnBrdrColor = `rgba(${parseInt(btnColor.slice(1,3),16)}, ${parseInt(btnColor.slice(3,5),16)}, ${parseInt(btnColor.slice(5,7),16)}, 0.3)`;

      const btnBackgColor = `rgba(${parseInt(btnColor.slice(1,3),16)}, ${parseInt(btnColor.slice(3,5),16)}, ${parseInt(btnColor.slice(5,7),16)}, 0.114)`;

 
      document.querySelector(".product-page").style.background = pagebg;




     document.querySelectorAll(".lab-link").forEach(el => {
      el.style.color = color;
      el.style.borderColor = color;
    });
    
    
    document.querySelectorAll(".gmp-card, .gmp-icon").forEach(el => {
  if (el.classList.contains("gmp-card")) {
    el.style.backgroundColor = iconsbg;
  }

  if (el.classList.contains("gmp-icon")) {
    el.style.color = color;
    el.style.backgroundColor = iconsin;
  }
});

  document.querySelectorAll(".product-callout__icon").forEach(el => {
  el.style.color = color;
   el.style.backgroundColor = pagebg;
});

 






       console.log(btnBrdrColor);
      const isNaNColor = btnBrdrColor.includes('NaN');
    
     // btn.style.background = selected ? btnColor : btnBackgColor;
     // btn.style.borderColor = selected ? btnColor : btnBrdrColor;
     // btn.style.color = selected ? (darkText ? '#1a1a1a' : '#fff') : '#333';
   btn.style.background = isNaNColor ? (selected ? '#333333' : '#f4f4f4') : (selected ? btnColor : btnBackgColor);
    btn.style.borderColor = isNaNColor ? '#000000' : (selected ? btnColor : btnBrdrColor);
     btn.style.color = isNaNColor ? (selected ? '#ffffff' : '#000000') : (selected ? (darkText ? '#1a1a1a' : '#fff') : '#333');
    
    
    });

    if (ctx.submitBtn) {
      ctx.submitBtn.style.background = color;
      ctx.submitBtn.style.color = darkText ? '#1a1a1a' : '#fff';
      if (!isAvailable) {
        ctx.submitBtn.textContent = 'Sold Out';
        ctx.submitBtn.disabled = true;
      } else {
        ctx.submitBtn.textContent = 'Add to Cart — ' + formatProductMoney(priceCents * quantity);
        ctx.submitBtn.dataset.readyText = ctx.submitBtn.textContent;
        ctx.submitBtn.disabled = false;
      }
    }
  }

  function selectProductVariant(page, btn) {
    if (!page || !btn) return;
    var ctx = getProductPageContext(page);
    if (ctx.variantInput && btn.getAttribute('data-variant-id')) {
      ctx.variantInput.value = btn.getAttribute('data-variant-id');
    }

    var selectedVariant = getSelectedProductVariant(ctx);
    setProductImage(ctx, getVariantImageUrl(selectedVariant, btn, ctx.defaultImageUrl));
    updateProductPageUI(page);
  }

  function setProductQuantity(page, value) {
    var ctx = getProductPageContext(page);
    var quantity = Math.max(1, parseInt(value, 10) || 1);
    if (ctx.qtyInput) ctx.qtyInput.value = quantity;
    if (ctx.qtyDisplay) ctx.qtyDisplay.textContent = quantity;
    if (ctx.qtyMinus) ctx.qtyMinus.disabled = quantity <= 1;
    updateProductPageUI(page);
  }

  function syncProductPage(page) {
    var ctx = getProductPageContext(page);
    setProductQuantity(page, getProductQuantity(ctx));

    var initialBtn = getActiveVariantButton(
      ctx.variantButtons,
      ctx.variantInput ? ctx.variantInput.value : ''
    );
    if (initialBtn) {
      selectProductVariant(page, initialBtn);
    } else {
      setProductImage(
        ctx,
        getVariantImageUrl(getSelectedProductVariant(ctx), null, ctx.defaultImageUrl)
      );
      updateProductPageUI(page);
    }
  }

  function refreshProductPages() {
    document.querySelectorAll('[data-product-page]').forEach(syncProductPage);
  }

  /* ── Product Page ── */
  function initProductPage() {
    if (initProductPage._bound) {
      refreshProductPages();
      return;
    }
    initProductPage._bound = true;

    document.addEventListener('click', function (event) {
      var variantBtn = event.target.closest('[data-variant-id]');
      if (variantBtn) {
        var variantPage = variantBtn.closest('[data-product-page]');
        if (variantPage) {
          event.preventDefault();
          selectProductVariant(variantPage, variantBtn);
          return;
        }
      }

      var minusBtn = event.target.closest('[data-quantity-minus]');
      if (minusBtn) {
        var minusPage = minusBtn.closest('[data-product-page]');
        if (minusPage) {
          event.preventDefault();
          var minusCtx = getProductPageContext(minusPage);
          setProductQuantity(minusPage, getProductQuantity(minusCtx) - 1);
        }
        return;
      }

      var plusBtn = event.target.closest('[data-quantity-plus]');
      if (plusBtn) {
        var plusPage = plusBtn.closest('[data-product-page]');
        if (plusPage) {
          event.preventDefault();
          var plusCtx = getProductPageContext(plusPage);
          setProductQuantity(plusPage, getProductQuantity(plusCtx) + 1);
        }
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      var page = event.target.querySelector('[data-product-page]');
      if (page) syncProductPage(page);
    });

    refreshProductPages();
  }


  /* ── Product format benefit tabs ── */
function activateFormatTab(id, focusTab) {
  const tabs = document.querySelectorAll('.why-tab');
  const activeTab = document.querySelector(`.why-tab[data-format-tab="${CSS.escape(id)}"]`);
  if (!activeTab) return;

  // Reset tabs state
  tabs.forEach(tab => {
    tab.classList.remove('active');
    tab.setAttribute('aria-selected', 'false');
    tab.setAttribute('tabindex', '-1');
  });

  // Activate selected tab
  activeTab.classList.add('active');
  activeTab.setAttribute('aria-selected', 'true');
  activeTab.setAttribute('tabindex', '0');

  // Reset and toggle panels
  document.querySelectorAll('.why-format-panel').forEach(panel => {
    panel.classList.remove('active');
    panel.setAttribute('hidden', '');
  });

  const activePanel = document.querySelector(`.why-format-panel[data-format-panel="${CSS.escape(id)}"]`);
  if (activePanel) {
    activePanel.classList.add('active');
    activePanel.removeAttribute('hidden');
  }

  if (focusTab) activeTab.focus(); 
}

// Delegated Click Event
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.why-tab');
  if (tab) {
    activateFormatTab(tab.dataset.formatTab, false);
  }
});

// Delegated Keydown Event
document.addEventListener('keydown', (e) => {
  const tab = e.target.closest('.why-tab');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;

  e.preventDefault();
  const tabs = Array.from(document.querySelectorAll('.why-tab'));
  let index = tabs.indexOf(tab);

  if (e.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
  if (e.key === 'ArrowRight') index = (index + 1) % tabs.length;
  if (e.key === 'Home') index = 0;
  if (e.key === 'End') index = tabs.length - 1;

  activateFormatTab(tabs[index].dataset.formatTab, true);
});




/* ── Education tabs ── */
function activateEducationTab(id, focusTab) {
  const tabs = document.querySelectorAll('.education-tab');
  const activeTab = document.querySelector(`.education-tab[data-education-tab="${CSS.escape(id)}"]`);
  if (!activeTab) return;

  // Reset tabs state
  tabs.forEach(tab => {
    tab.classList.remove('active');
    tab.setAttribute('aria-selected', 'false');
    tab.setAttribute('tabindex', '-1');
  });

  // Activate selected tab
  activeTab.classList.add('active');
  activeTab.setAttribute('aria-selected', 'true');
  activeTab.setAttribute('tabindex', '0');

  // Reset and toggle panels
  document.querySelectorAll('.education-panel').forEach(panel => {
    panel.classList.remove('active');
    panel.setAttribute('hidden', '');
  });

  const activePanel = document.querySelector(`.education-panel[data-education-panel="${CSS.escape(id)}"]`);
  if (activePanel) {
    activePanel.classList.add('active');
    activePanel.removeAttribute('hidden');
  }

  if (focusTab) activeTab.focus();
}

// Delegated Click Event
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.education-tab');
  if (tab) {
    activateEducationTab(tab.dataset.educationTab, false);
  }
});

// Delegated Keydown Event
document.addEventListener('keydown', (e) => {
  const tab = e.target.closest('.education-tab');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;

  e.preventDefault();
  const tabs = Array.from(document.querySelectorAll('.education-tab'));
  let index = tabs.indexOf(tab);

  if (e.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
  if (e.key === 'ArrowRight') index = (index + 1) % tabs.length;
  if (e.key === 'Home') index = 0;
  if (e.key === 'End') index = tabs.length - 1;

  activateEducationTab(tabs[index].dataset.educationTab, true);
});
















  /* ── Product Thumbnails ── */
  function initProductThumbnails() {
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;

      var page = thumb.closest('[data-product-page]') || document;
      var productImage = page.querySelector('[data-product-image]') || document.getElementById('product-main-image');
      var imageUrl = thumb.getAttribute('data-image');
      if (!productImage || !imageUrl) return;

      productImage.src = imageUrl;
      if (productImage.hasAttribute('srcset')) productImage.removeAttribute('srcset');
      page.querySelectorAll('[data-product-thumb]').forEach(function (item) {
        item.classList.toggle('active', item === thumb);
      });
    });
  }

  /* ── Add to Cart (Shopify AJAX) ── */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'product-form') return;

      e.preventDefault();
      var btn = form.querySelector('.add-to-cart-btn');
      if (btn) {
        btn.textContent = 'Adding...';
        btn.disabled = true;
      }

      var formData = new FormData(form);
      var quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
      var data = { items: [{ id: formData.get('id'), quantity: quantity }] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added!'; }
        updateCartCount();
        setTimeout(function () {
          if (btn) {
            btn.textContent = btn.dataset.readyText || 'Add to Cart';
            btn.disabled = false;
          }
        }, 2000);
      })
      .catch(function () {
        if (btn) { btn.textContent = 'Error — Try Again'; btn.disabled = false; }
      });
    });
  }

  /* ── Cart Count ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (!el) return;
        var count = cart.item_count || 0;
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
  }

  /* ── Scroll Fade-In Animation ── */
  function initScrollFade() {
    if (!window.IntersectionObserver) return;
    var items = document.querySelectorAll('[data-fade]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.fadeDelay || 0;
          setTimeout(function () {
            entry.target.classList.add('visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach(function (item) { observer.observe(item); });
  }

  /* ── Init on DOM ready ── */
  document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
    initMobileMenu();
    initFaqAccordion();
    initProductPage();
    initProductThumbnails();
    initAddToCart();
    updateCartCount();
    initScrollFade();
  });

})();
